import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const DoubleTicks = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M29 8C28.7239 8 28.4739 8.112 28.2929 8.29288L15 21.5858L9.70712 16.2929C9.52612 16.112 9.27612 16 9 16C8.44775 16 8 16.4478 8 17C8 17.2761 8.11188 17.5261 8.29288 17.7071L14.2929 23.7071C14.4881 23.9024 14.744 24 15 24C15.256 24 15.5119 23.9024 15.7071 23.7071L29.7071 9.70712C29.8881 9.52612 30 9.27612 30 9C30 8.44775 29.5522 8 29 8Z" />
		<path d="M22 9C22 8.44775 21.5522 8 21 8C20.7239 8 20.4739 8.112 20.2929 8.29288L14.2929 14.2929C14.1119 14.4739 14 14.7239 14 15C14 15.5522 14.4477 16 15 16C15.2761 16 15.5261 15.888 15.7071 15.7071L21.7071 9.70712C21.8881 9.52612 22 9.27612 22 9Z" />
		<path d="M7 24C7.55225 24 8 23.5522 8 23C8 22.7239 7.888 22.4739 7.70713 22.2929L3.70712 18.2929C3.52612 18.1119 3.27612 18 3 18C2.44775 18 2 18.4477 2 19C2 19.2761 2.112 19.5261 2.29288 19.7071L6.29287 23.7071C6.47388 23.8881 6.72388 24 7 24Z" />
	</svg>
);

export default DoubleTicks;
